import { t } from 'i18next';
import React, { useReducer } from 'react'
import { useNavigate } from 'react-router-dom';
import { getAccessBuildingsService } from '../../services/accessBuildings';
import AccessBuildingContext from './AccessBuildingContext'
import AccessBuildingReducer from './AccessBuildingReducer';
import { logout } from '../../services/login';
import { setUserData } from '../../helpers/helpers';

const AccessBuildingState = ({ children }) => {

    const initialState = {
        accessBuildings: [],
        accessBuildingsSearchable: [],
        isFetching: true,
        wasFetched: false,
        error: false,
        message: ''
    };

    const [state, dispatch] = useReducer(AccessBuildingReducer, initialState);

    const navigate = useNavigate();

    const setAccessBuilding = (accessBuilding) => {
        const userData = JSON.parse(localStorage.getItem('userData'));
        const newData = {
            ...userData,
            accessBuilding
        }
        setUserData(newData)
    };

    const getAccessBuildings = async (isFilter = false, openingCodes) => {
        try {
            const response = await getAccessBuildingsService({ openingCodes });
            if (response.ok) {
                if (isFilter === false) {
                    if (response.data.response.length === 0) {
                        setAccessBuilding({
                            "buildingId": "",
                            "buildingCode": "",
                            "buildingDescription": t('NO_BUILDING'),
                            "opening": null
                        })
                        navigate('/dashboard');
                    }

                    if (response.data.response.length === 1) {
                        setAccessBuilding(response.data.response[0])
                        navigate('/dashboard');
                    }
                }
                dispatch({
                    type: 'GET_ACCESS_BUILDINGS',
                    payload: response.data.response
                })
            } else {
                const errorType = await response.data.json();
                switch (errorType.error_code) {
                    case 'AUTH_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('TOKEN_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('ERROR_TRY_AGAIN')
                        })
                        break;
                }
            }
        } catch (e) {
            console.log(e);
            dispatch({
                type: 'ERROR_SERVER',
                payload: t('SERVER_ERROR')
            });
        }
    }

    const setAccessBuildingSearchable = (newAccessBuildingsSearchable) => {
        dispatch({ type: 'SET_ACCESS_BUILDING_SEARCHABLE', payload: newAccessBuildingsSearchable });
    }

    return (
        <AccessBuildingContext.Provider
            value={{
                accessBuildingState: state,
                getAccessBuildings,
                setAccessBuilding,
                setAccessBuildingSearchable
            }}
        >
            {children}
        </AccessBuildingContext.Provider>
    )
}

export default AccessBuildingState